import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../../context/AuthContext";
import SafraContext from "../../../context/SafraContext";
import {Toast} from "primereact/toast";
import Loader from "../../util/Loader";


import tableLang from '../../../locales/tabulator.loc.json'
import {TabulatorFull as Tabulator} from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import {useForm} from "react-hook-form";
import ControlContext from "../../../context/ControlContext";
import RHFSelect from "../../forms/RHFSelect";
import BarChart from "../../charts/BarChart";


const ResumoProduto = ({view, title}) => {

    const {t} = useTranslation();

    const {user, clientID} = useContext(AuthContext);
    const {titles} = useContext(ControlContext);
    const {resumoProduto} = useContext(SafraContext);

    const toast = useRef(null);

    const [loader, setLoader] = useState({show:true, msg:"", error:false});
    const [tabulator, setTabulator] = useState(null);
    const [data, setData] = useState();
    const [columns, setColumns] = useState();

    const SUMs = ["volume","custo"]
    const FKs = ["safra", "unidade", "sub_unidade", "grupo_produto", "produto"]
    const [filterSelectList, setFilterSelectList] = useState({});
    const [selectedFilter, setSelectedFilter] = useState({});
    const [filteredData, setFilteredData] = useState({});
    const selectRef = useRef({});

    const [barChartConfig, setBarChartConfig] = useState({})

    const tabulatorRef = useRef();

    useEffect(() => {
        const init = async ()=>{
            const rs = await resumoProduto(view);
            const columns = [
                {"title":t("nome"), "field":"nome", "formatter":(cell)=>{
                        const value = cell.getValue();
                        const row = cell.getRow();
                        const rowData = row.getData();
                        return (rowData.unidade) ? rowData.unidade+' - '+value : value;
                }},
                {"title":t('volume'), "field":"volume", "formatter": "money", "formatterParams": {"decimal": ",","thousand": ".","precision": 2}},
                {"title":t('custo'), "field":"custo", "formatter": "money", "formatterParams": {"decimal": ",","thousand": ".","precision": 2}},
            ];
            setColumns(columns);
            setData(rs);
        }
        setLoader({show:true, msg:'', error:false})
        init().then(()=>{
            setLoader({show:false, msg:'', error:false})
        }).catch(err=>{
            setLoader({show:false, msg:'', error:true})
            console.error(err);
        })
        return () => {
            setLoader({show:true, msg:'', error:false})
        };
    }, []);

    useEffect(()=>{
        if(tabulator && data && columns){
            //console.log(data);
            tabulator.setColumns(columns);
            tabulator.setData(data);
            tabulator.redraw();

            const listMap = buildFilterSelect(data);
            setFilterSelectList(listMap);

            setLoader({show:false, msg:"", error:false});
        }
    },[tabulator, data, columns])

    const optionsDT = {
        selectableRows:false,
        height:"100%",
        data:[],

        dataTree:true,
        dataTreeCollapseElement:'<span class="mr-1 cursor-pointer"><i class="icon-minus2"></i></span>',
        dataTreeExpandElement:'<span class="mr-1 cursor-pointer"><i class="icon-plus2"></i></span>',
        dataTreeStartExpanded:[true, false],

        columnHeaderVertAlign:"bottom",
        clipboard:true,
        clipboardCopyRowRange:'selected',
        clipboardCopyStyled:false,
        clipboardCopyConfig:{
            columnHeaders:false,
            columnGroups:false,
            rowGroups:false,
            formatCells:true
        },
        placeholder:t('msg_nenhum_registro'),
        columns:[],

        layout: "fitColumns",
        reactiveData:true,
        locale:'pt-br',
        langs:tableLang,
        addRowPos:'top',
        validationMode:"manual",
        rowFormatter: (row) => {
            const data = row.getData();
            if (row.getTreeParent() === false) {
                row.getElement().style.backgroundColor = "#f4f4f4";
                return;
            }
            if(data._nivel === "sub_unidade"){
                row.getElement().style.backgroundColor = "#F4F4F480";
            }
        }
    };

    useEffect(()=>{
        const tabulatorInstance = new Tabulator(tabulatorRef.current, optionsDT);
        tabulatorInstance.on("tableBuilt", ()=>{
            tabulatorInstance.deselectRow();
            setTabulator(tabulatorInstance);
        });
        return () => {
            if (tabulatorInstance) {
                tabulatorInstance.destroy();
            }
            if (tabulator) {
                tabulator.destroy();
            }
        };
    },[])

    const {
        register,
        control,
        watch,
        handleSubmit,
        reset,
        setFocus,
        setValue,
        setError,
        clearErrors,
        formState: { errors }
    } = useForm();

    const buildFilterSelect = (data)=>{
        const _map = {}
        for(const [, fk] of FKs.entries()){
            _map[fk] = {};
        }

        const buildMap = (name, item, mapIds)=>{
            if(!_map[name][item._id]) _map[name][item._id] = {...item, _children:[]}
            for(const [, key] of FKs.entries()){
                if(key === name) continue;
                if(!_map[name][item._id]["_"+key]) _map[name][item._id]["_"+key] = [];
                if(!_map[name][item._id]["_"+key].includes(mapIds[key]._id)){
                    _map[name][item._id]["_"+key].push(mapIds[key]._id)
                }
            }
        }

        const sum = (filter, item)=>{
            for(const [, key] of SUMs.entries()){
                filter[key] += item[key]
            }
        }
        const zero = (filter)=>{
            for(const [, key] of SUMs.entries()){
                filter[key] = 0
            }
        }

        //Customizar por resumo
        for(const [, safra] of data.entries()){
            zero(safra);
            for(const [, sub_unidade] of safra._children.entries()){
                zero(sub_unidade)
                for(const [, grupo_produto] of sub_unidade._children.entries()){
                    zero(grupo_produto);
                    for(const [, produto] of grupo_produto._children.entries()){
                        const mapIds = {safra, sub_unidade, unidade:{_id:sub_unidade._id_unidade}, grupo_produto, produto}
                        buildMap('safra', safra, mapIds)
                        buildMap('sub_unidade', sub_unidade, mapIds)
                        buildMap('grupo_produto', grupo_produto, mapIds)
                        buildMap('produto', produto, mapIds)
                        buildMap('unidade', {_id:sub_unidade._id_unidade, nome: sub_unidade.unidade}, mapIds)

                        sum(grupo_produto, produto);
                    }
                    sum(sub_unidade, grupo_produto);
                }
                sum(safra, sub_unidade);
            }
        }

        const listMap= {}
        for(const [, fk] of FKs.entries()){
            listMap[fk] = Object.values(_map[fk])
        }

        return listMap;
    }

    const handleChangeFilter = (name, selectedValue)=>{
        setSelectedFilter((prevState)=>{
            if(!selectedValue){
                const newState = {...prevState};
                delete newState[name];
                return newState;
            }
            return {...prevState, [name]:selectedValue}
        })
    }

    useEffect(() => {
        if(data && selectedFilter){
            const dataCopy = JSON.parse(JSON.stringify(data));
            const _filteredData = dataCopy.filter((safra)=>{
                safra._children = safra._children.filter((sub_unidade)=>{
                    sub_unidade._children = sub_unidade._children.filter((grupo_produto)=>{
                        grupo_produto._children = grupo_produto._children.filter((produto)=>{
                            return !(
                                (selectedFilter.produto && produto._id !== selectedFilter.produto.value)
                            );
                        })
                        return !(
                            grupo_produto._children.length === 0 ||
                            (selectedFilter.grupo_produto && grupo_produto._id !== selectedFilter.grupo_produto.value)
                        );
                    })
                    return !(
                        sub_unidade._children.length === 0 ||
                        (selectedFilter.sub_unidade && sub_unidade._id !== selectedFilter.sub_unidade.value) ||
                        (selectedFilter.unidade && sub_unidade._id_unidade !== selectedFilter.unidade.value)
                    );
                })
                return !(
                    safra._children.length === 0 ||
                    (selectedFilter.safra && safra._id !== selectedFilter.safra.value)
                );
            });
            const listMap = buildFilterSelect(_filteredData);
            setFilterSelectList(listMap);
            setFilteredData(_filteredData);

            tabulator.setData(_filteredData);

            const _barChartConfig = {
                indexBy:"grupo_produto",
                keys:['Custo'],
                colors:["#ffbbbb"],
                data:[]
            }
            const grupoProdutoMap = {}
            for(const [, safra] of _filteredData.entries()) {
                for (const [, sub_unidade] of safra._children.entries()) {
                    for (const [, grupo_produto] of sub_unidade._children.entries()) {
                        if(!grupoProdutoMap[grupo_produto._id]){
                            grupoProdutoMap[grupo_produto._id] = {custo:0, grupo_produto};
                        }
                        grupoProdutoMap[grupo_produto._id].custo += grupo_produto.custo;
                    }
                }
            }
            for(const [, {custo, grupo_produto}] of Object.values(grupoProdutoMap).entries()){
                _barChartConfig.data.push({
                    grupo_produto:grupo_produto.nome,
                    Custo:custo
                })
            }
            setBarChartConfig(_barChartConfig);
        }
    }, [data, selectedFilter]);

    const exportar_xlsx = async (event)=>{
        if(tabulator && filteredData){
            const flatData = []
            const header = [t('safra'), t('unidade'), t('sub_unidade'), t('grupo_produto'), t('produto')]
            for(const [, column] of columns.entries()){
                if(column.field === 'nome') continue;
                header.push(column.title);
            }
            for(const [, safra] of filteredData.entries()){
                for(const [, sub_unidade] of safra._children.entries()){
                    for(const [, grupo_produto] of sub_unidade._children.entries()){
                        for(const [, produto] of grupo_produto._children.entries()){
                            const line = [safra.nome, sub_unidade.unidade, sub_unidade.nome, grupo_produto.nome, produto.nome]
                            for(const [, column] of columns.entries()){
                                if(column.field === 'nome') continue;
                                line.push(produto[column.field]);
                            }
                            flatData.push(line);
                        }
                    }
                }
            }
            const worksheet = window.XLSX.utils.aoa_to_sheet([
                header,
                ...flatData
            ])
            const workbook = window.XLSX.utils.book_new();
            window.XLSX.utils.book_append_sheet(workbook, worksheet, titles[view]);
            window.XLSX.writeFile(workbook, titles[view]+".xlsx");
        }
    }

    return (
        <>
            <Loader type="content" show={loader.show} msg={loader.msg}/>
            <Toast ref={toast} appendTo={"self"} position="bottom-center"/>
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-2">
                        <div className={"card-header border-bottom p-1 pl-2 header-elements-inline"} style={{backgroundColor: "#f0f2f5"}}>
                            <span className="card-title font-weight-bold font-size-lg">{titles[view]}</span>
                            <div className="header-elements">
                                <button type="button" data-pr-tooltip={t('exportar_tipo', {tipo: 'XLSX'})} data-pr-position="top" className="btn btn-icon btn-light text-green"
                                        onClick={(e) => exportar_xlsx(e)}>
                                    <i className="icon-file-excel"></i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body border-bottom p-1 w-100">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <label className="col-form-label col-lg-2 text-right font-weight-bold">{t('safra')}</label>
                                        <div className="col-lg-10">
                                            <RHFSelect
                                                ref={el => selectRef.current["safra"] = el}
                                                name={"safra"}
                                                placeholder={t('selecione')}
                                                control={control}
                                                options={(filterSelectList && filterSelectList["safra"]) ? filterSelectList["safra"].map((item) => {
                                                    return {label: item.nome, value: item._id}
                                                }) : []}
                                                handleChange={handleChangeFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-md-6">
                                    <div className="row">
                                        <label className="col-form-label col-lg-2 text-right font-weight-bold">{t('unidade')}</label>
                                        <div className="col-lg-10">
                                            <RHFSelect
                                                ref={el => selectRef.current["unidade"] = el}
                                                name={"unidade"}
                                                placeholder={t('selecione')}
                                                control={control}
                                                options={(filterSelectList && filterSelectList["unidade"]) ? filterSelectList["unidade"].map((item) => {
                                                    return {label: item.nome, value: item._id}
                                                }) : []}
                                                handleChange={handleChangeFilter}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <label className="col-form-label col-lg-2 text-right font-weight-bold">{t('sub_unidade')}</label>
                                        <div className="col-lg-10">
                                            <RHFSelect
                                                ref={el => selectRef.current["sub_unidade"] = el}
                                                name={"sub_unidade"}
                                                placeholder={t('selecione')}
                                                control={control}
                                                options={(filterSelectList && filterSelectList["sub_unidade"]) ? filterSelectList["sub_unidade"].map((item) => {
                                                    return {label: item.nome, value: item._id}
                                                }) : []}
                                                handleChange={handleChangeFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <label className="col-form-label col-lg-2 text-right font-weight-bold">{t('grupo_produto')}</label>
                                        <div className="col-lg-10">
                                            <RHFSelect
                                                ref={el => selectRef.current["grupo_produto"] = el}
                                                name={"grupo_produto"}
                                                placeholder={t('selecione')}
                                                control={control}
                                                options={(filterSelectList && filterSelectList["grupo_produto"]) ? filterSelectList["grupo_produto"].map((item) => {
                                                    return {label: item.nome, value: item._id}
                                                }) : []}
                                                handleChange={handleChangeFilter}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <label className="col-form-label col-lg-2 text-right font-weight-bold">{t('produto')}</label>
                                        <div className="col-lg-10">
                                            <RHFSelect
                                                ref={el => selectRef.current["produto"] = el}
                                                name={"produto"}
                                                placeholder={t('selecione')}
                                                control={control}
                                                options={(filterSelectList && filterSelectList["produto"]) ? filterSelectList["produto"].map((item) => {
                                                    return {label: item.nome, value: item._id}
                                                }) : []}
                                                handleChange={handleChangeFilter}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"card-header border-bottom p-1"} style={{backgroundColor: "#f0f2f5"}}></div>
                        <div style={{position: "relative"}}>
                            <Loader type="card" show={loader.show} msg={loader.msg}/>
                            <div ref={tabulatorRef}></div>
                        </div>
                        <div className={"card-header border-bottom p-1"} style={{backgroundColor: "#f0f2f5"}}></div>
                        <div className="card-body p-2">
                            <div style={{height: "400px"}}>
                                <BarChart config={barChartConfig} layout={'vertical'} marginLeft={100} marginBottom={120}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default ResumoProduto